import React from "react";
import isArray from "lodash/isArray";
import ResourceSelectLazyLoading from "../../ResourceSelectLazyLoading";
import { FILTER_TYPE_SELECT_MODE_1, FILTER_TYPE_SELECT_MODE_2, FILTER_TYPE_SELECT_MODE_3 } from "../methods";
import FilterDropdownButtons from "./FilterDropdownButtons";

export const getColumnResourceSelectFilterProps = ({ tableParams = {}, column = {} }) => {
  const { apiRoute, ...rest } = column?.filterProps || {};

  let filterColumn;
  if (column.filterType === FILTER_TYPE_SELECT_MODE_1 || column.filterType === FILTER_TYPE_SELECT_MODE_3) {
    filterColumn = tableParams.anotherFilters?.find((item) => item.column === column.dataIndex);
  }

  if (column.filterType === FILTER_TYPE_SELECT_MODE_2) {
    filterColumn = tableParams.filters?.find((item) => item.column === column.dataIndex);
  }

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div className="table-filter-dropdown select-filter-dropdown">
        <ResourceSelectLazyLoading
          getPopupContainer={() => document.body}
          variant="outlined"
          size="normal"
          showArrow
          showSearch
          allowClear
          apiRoute={apiRoute}
          value={selectedKeys[0]?.value}
          initialValue={
            filterColumn
              ? {
                  id: isArray(filterColumn.value) ? filterColumn.value[0] : filterColumn.value,
                  text: filterColumn.text,
                  transKey: filterColumn.transKey
                }
              : null
          }
          onChange={(value, objValue) => {
            setSelectedKeys(value ? [{ ...objValue, column: column.dataIndex }] : []);
          }}
          {...rest}
        />
        <FilterDropdownButtons confirm={confirm} />
      </div>
    ),
    filteredValue: filterColumn ? [filterColumn] : null
  };
};
